import theme from "theme/index";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { CssBaseline, ThemeProvider } from "@mui/material";

import InterceptorProvider from "context/with-interceptor-provider";

import browserRouters from "routes/routes";

import store, { persistor } from "store/store";

const App = () => {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />

			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<InterceptorProvider routes={browserRouters}>
						<RouterProvider router={browserRouters} />
					</InterceptorProvider>
				</PersistGate>
			</Provider>
		</ThemeProvider>
	);
};

export default App;
